@for (section of sections$ | async; track section.id) {
  @if (section.items.length > 0) {
    <div class="section-item" (click)="expandSection(section)" [dataSelector]="dataSelector + '-section-' + section.id">
      <span class="h4-400" [dataSelector]="dataSelector + '-section-name-' + section.id">
        @if ((enableReferenceId$ | async) && section.referenceId) {
          <span class="reference-id">{{ section.referenceId }}. </span>
        }
        {{ section.name }}
      </span>

      <aiwyn-icon [name]="expandedSections[section.id] ? 'chevron-down' : 'chevron-right'" [height]="16" [width]="16" [dataSelector]="dataSelector + '-section-toggle-' + section.id"></aiwyn-icon>
    </div>

    <div *ngIf="expandedSections[section.id]" class="request-item-list" [dataSelector]="dataSelector + '-section-items-' + section.id">
      @for (requestItem of section.items; track requestItem.id) {
        <awn-request-item-line
          [requestItem]="requestItem"
          [dataSelectorStr]="dataSelector"
          [sectionReferenceId]="(enableReferenceId$ | async) ? section.referenceId : undefined">
        </awn-request-item-line>
      }
    </div>
  }
}
